import { DeepReadonly, IntakeStatus, IOffer } from 'types';
import { deepFreeze } from '../utils/deepFreeze';

export const defaultOffer: DeepReadonly<IOffer> = deepFreeze({
  intakeId: '',
  offerId: '',
  intakeStatus: IntakeStatus.ACTIVE
});
